import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_HOMES = `${HOME_SERVICE}/floors`;

export const floors = {
  getAll: async ({ filters, sort, params, signal, top, skip } = {}) => {
    const options = await apiOptions({
      url: API_HOMES,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      filters,
      sort,
      params,
      signal,
      top,
      skip,
    });
    return apiRequest(options);
  },
  getById: async ({ id } = {}) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: API_HOMES,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  reorder: async ({ data, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: `${API_HOMES}/reorder`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, modifiedOn, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data: { modifiedOn },
    });
    return apiRequest(options, toastMessageConfig);
  },
};
